import { render, staticRenderFns } from "./EditCoaching.vue?vue&type=template&id=b08e7e12&scoped=true"
import script from "./EditCoaching.vue?vue&type=script&lang=js"
export * from "./EditCoaching.vue?vue&type=script&lang=js"
import style0 from "./EditCoaching.vue?vue&type=style&index=0&id=b08e7e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e7e12",
  null
  
)

export default component.exports